declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage(message: string): void;
    };
  }
}

const sendMessageToParent = (eventName: string, data = {}) => {
  try {
    if (window.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({ action: eventName, data })
      );
    } else {
      console.warn("ReactNativeWebView is not available on the window object.");
    }
  } catch (error) {
    console.error("sendMessageToParent ERROR", error);
  }
};

export const isInApp = (): boolean => {
  return Boolean(window?.ReactNativeWebView);
};

export const isInWeb = (): boolean => {
  return !isInApp();
};

export default sendMessageToParent;
